import types from './siteTypes'

const mutations = {
  [types.SET_SITES](state, payload) {
    state.sites = payload.sites
  },

  [types.CLEAR_SITES](state) {
    state.sites = []
  },

  [types.SET_ACTIVE_SITE](state, payload) {
    state.site = payload.site
  },

  [types.CLEAR_ACTIVE_SITE](state) {
    state.site = {}
  },
}

export default mutations
